jQuery(document).ready(function($) {
	"use strict";

    // interior banners parallax functions
    var $IBparallax = jQuery('.interior-banner .image');
    if ($IBparallax.length) {
        var yPos = jQuery(window).scrollTop() / 5;
        $IBparallax.css({ "transform": "translate3d(0px, " + yPos + "px, 0px)" });
        jQuery(window).scroll(function() {
            var yPos = jQuery(window).scrollTop() / 5;
            $IBparallax.css({ "transform": "translate3d(0px, " + yPos + "px, 0px)" });
        });
    }

	/* Add alt tags to blackbaud embeded form - /dallas-high-school-mens-group-scholarship-donation-form/ */
	if ( ! has_bbformFinished() ) {
		setTimeout( function() { add_bbFormImgAlt(); }, 3000 );
	}

	/* header */
    jQuery('.toggle-quick-links').click(function(ev){
        ev.stopPropagation();
        ev.preventDefault();
        if ( jQuery(this).hasClass('active')) {
            jQuery(this).removeClass('active');
            jQuery('.quick-links').animate({height: 'hide'}, 700, 'easeOutQuint');
        } else {
            jQuery(this).addClass('active');
            jQuery('.quick-links').animate({height: 'show'}, 700, 'easeOutQuint');
            jQuery('.search-form').animate({height: 'hide'}, 700, 'easeOutQuint');
            jQuery('.toggle-search').removeClass('active');
						jQuery( '.quick-links-ct .column.first li:first-child a' ).focus();
        }
    });
		jQuery( '.toggle-quick-links-focus' ).keyup( function( e ) {
			if ( e.keyCode === 13 ) {
				jQuery( '.toggle-quick-links' ).trigger( 'click' );
			}
		});
    jQuery('.toggle-search').click(function(ev){
        ev.stopPropagation();
        ev.preventDefault();
        if ( jQuery(this).hasClass('active')) {
            jQuery(this).removeClass('active');
            jQuery('.search-form').animate({height: 'hide'}, 700, 'easeOutQuint');
        } else {
            jQuery(this).addClass('active');
            jQuery('.search-form').animate({height: 'show'}, 700, 'easeOutQuint');
            jQuery('.quick-links').animate({height: 'hide'}, 700, 'easeOutQuint');
            jQuery('.toggle-quick-links').removeClass('active');
        }
    });
    jQuery('.quick-links').click(function(ev) {
        ev.stopPropagation();
    });
    jQuery('.search-form').click(function(ev) {
        ev.stopPropagation();
    });
    jQuery('body').click(function() {
        jQuery('.quick-links').animate({height: 'hide'}, 700, 'easeOutQuint');
        jQuery('.toggle-quick-links').removeClass('active');
        jQuery('.search-form').animate({height: 'hide'}, 700, 'easeOutQuint');
        jQuery('.toggle-search').removeClass('active');
    });

    // header scroll
    var scrTop = jQuery(window).scrollTop();
    if (scrTop > 400) {
        jQuery('.site-header').addClass('passed');
    } else {
        jQuery('.site-header').removeClass('passed');
    }
    jQuery(window).on('scroll', function(){
        var scrTop = jQuery(window).scrollTop();
        if (scrTop > 400) {
            jQuery('.site-header').addClass('passed');
        } else {
            jQuery('.site-header').removeClass('passed');
        }
    });
    var position = $(window).scrollTop();
    $(window).scroll(function() {
        var scroll = $(window).scrollTop();
        if(scroll > position) {
        } else {
            jQuery('.site-header').removeClass('passed');
        }
        position = scroll;
    });

    // main-menu functions
		jQuery( '.main-menu > ul > li' ).focusin( function() {
			jQuery( '.has-focus' ).removeClass( 'has-focus' );
			if ( ! jQuery( this ).hasClass( 'has-focus' ) ) {
				jQuery( this ).addClass( 'has-focus' );
			}
		});

		jQuery( '.main-menu > ul > li' ).focusout( function() {
			if ( ! jQuery( this ).is( ':focus-within' ) ) {
				jQuery( this ).removeClass( 'has-focus' );
			}
		});

    jQuery('.main-menu > ul > .menu-item-has-children > ul > .menu-item-has-children > a').each(function(){
        jQuery(this).wrapAll( '<div class="parent"></div>');
        jQuery(this).parent('.parent').append('<div class="show-submenu" data-level="l1"><a href="javascript:void(0);"><span class="fas fa-arrow-circle-right" title="Open ' + jQuery( this ).text() + ' Submenu"></span></a></div>');
        var ltxt = jQuery(this).text();
        jQuery(this).parent('.parent').siblings('ul').prepend('<li><div class="top"><div class="back"><a href="javascript:void(0);" class="back"><span class="fas fa-arrow-circle-left" title="Close ' + ltxt + ' Submenu"></span>'+ltxt+'</a></div></div></li>');
    });
    jQuery('.main-menu > ul > .menu-item-has-children > ul').each(function(){
        jQuery(this).wrapAll( '<div class="submenu"><div class="submenu-default-menu-list"></div></div>');
    });
    jQuery('body').click(function(){
        jQuery('.main-menu li').removeClass('active');
    })
    jQuery('.close-megamenu').click(function(){
        jQuery('.main-menu li').removeClass('active');
    })
    jQuery('.main-menu').click(function(ev){
        ev.stopPropagation();
    });
    jQuery('.submenu .show-submenu').click(function(ev){
        var mmlevel =  jQuery(this).attr('data-level');
        jQuery(this).parents('.submenu-default-menu-list').addClass('active-'+mmlevel);
        var mmheightS = jQuery(this).parent('.parent').siblings('ul').outerHeight();
        jQuery(this).parents('.submenu').css('height', mmheightS+'px');
        jQuery(this).parent('.parent').siblings('ul').addClass('active-list');
				jQuery( this ).parent( '.parent' ).parent( 'li' ).addClass( 'submenu-focus-within' );
				jQuery( this ).children().addClass( 're-focus' );
				focus_submenu();
    });
		function focus_submenu() {
			setTimeout( function() {
				jQuery( '.active-list' ).children( 'li:first-child' ).find( 'a' ).focus();
			}, 500);
		}
    jQuery(window).on('resize', function(){
        var mmheightS = jQuery('.submenu-default-menu-list ul.active-list').outerHeight();
        jQuery('.submenu').css('height', mmheightS+'px');
    });
    jQuery('.submenu .back').click(function(ev){
        var mmlevelC = jQuery(this).closest('.active-list').siblings('.parent').find('.show-submenu').attr('data-level');
        var mmnextHeight = jQuery(this).closest('.active-list').parent('li').parent('ul').outerHeight();
        jQuery(this).parents('.submenu').css('height', mmnextHeight+'px');
        jQuery(this).parent('.top').parent('li').parent('ul').removeClass('active-list');
        jQuery(this).parents('.submenu-default-menu-list').removeClass('active-'+mmlevelC);
				if ( jQuery( this ).focusin() ) {
					jQuery( 'a.re-focus' ).focus();
					jQuery( 'a.re-focus' ).removeClass();
					jQuery( '.submenu-focus-within' ).removeClass( 'submenu-focus-within' );
				}
    });
		jQuery( 'html' ).on( 'focusout', '.submenu-focus-within li:last-child', function( r ) {
			if ( ! jQuery( r['relatedTarget'] ).closest( 'ul' ).hasClass( 'active-list' ) ) {
				jQuery( this ).closest( '.sub-menu' ).find( '.back' ).trigger( 'click' );
			}
		});

		jQuery( 'html' ).on( 'focusin', '.re-focus', function() {
			if ( jQuery( this ).parents( '.submenu-default-menu-list' ).hasClass( 'active-l1' ) ) {
				jQuery( '.submenu .submenu-focus-within .back' ).trigger( 'click' );
			};
			jQuery( '.re-focus' ).removeClass();
		});

		jQuery( 'html' ).on( 'focusout', '.quick-links-ct a', function( r ) {
			if ( ! jQuery( r['relatedTarget'] ).parents( 'ul' ).hasClass( 'quick-links-column' ) ) {
				jQuery( '.toggle-quick-links' ).trigger( 'click' ).focus();
			}
		});

    jQuery('body').click(function(){
        jQuery('.main-menu .submenu').css('height', 'auto');
        jQuery('.main-menu .submenu ul').removeClass('active-list');
        jQuery('.main-menu .submenu-default-menu-list').removeClass('active-l1');
        jQuery('.main-menu .submenu-default-menu-list').removeClass('active-l2');
    });

    /* mobile-menu */
    jQuery('.mobile-menu-ct .menu-item-has-children > a').each(function(){
        jQuery(this).wrapAll( '<div class="parent"></div>');
        jQuery(this).parent('.parent').append('<div class="show-submenu"><span class="fas fa-arrow-circle-right" title="Open ' + jQuery( this ).text() + ' Submenu"></span></div>');
    });
    jQuery('.toggle-mobile-menu').click(function(ev){
        ev.stopPropagation();
        if ( jQuery(this).hasClass('active')) {
            jQuery(this).removeClass('active');
            jQuery('body').removeClass('mobile-menu-active');
            jQuery(this).find('.top-bar').removeClass('rotate');
            jQuery(this).find('.top-bar').removeClass('middle');
            jQuery(this).find('.bottom-bar').removeClass('rotate');
            jQuery(this).find('.bottom-bar').removeClass('middle');

        } else {
            jQuery(this).addClass('active');
            jQuery('body').addClass('mobile-menu-active');
            jQuery(this).find('.top-bar').addClass('middle');
            jQuery(this).find('.top-bar').addClass('rotate');
            jQuery(this).find('.bottom-bar').addClass('middle');
            jQuery(this).find('.bottom-bar').addClass('rotate');
        }
    });
    jQuery('body').click(function(){
        jQuery('.toggle-mobile-menu').removeClass('active');
        jQuery('body').removeClass('mobile-menu-active');
        jQuery('.toggle-mobile-menu .top-bar').removeClass('rotate');
        jQuery('.toggle-mobile-menu .top-bar').removeClass('middle');
        jQuery('.toggle-mobile-menu .bottom-bar').removeClass('rotate');
        jQuery('.toggle-mobile-menu .bottom-bar').removeClass('middle');
    });
    jQuery('.mobile-menu').click(function(ev) {
        ev.stopPropagation();
    });
    jQuery('.mobile-menu .show-submenu').click(function(ev){
        ev.preventDefault();
        if ( jQuery(this).hasClass('active')) {
            jQuery(this).removeClass('active');
            jQuery(this).parents('.parent').siblings('ul').animate({opacity: 'hide', height: 'hide'}, 700, 'easeOutQuint');
        } else {
            jQuery(this).parents('.parent').parent('li').siblings('li').each(function(){
                if (jQuery(this).find('.show-submenu').hasClass('active')) {
                    jQuery(this).find('.show-submenu').removeClass('active');
                    jQuery(this).find('ul').animate({opacity: 'hide', height: 'hide'}, 700, 'easeOutQuint');
                }
            });
            jQuery(this).addClass('active');
            jQuery(this).parents('.parent').siblings('ul').animate({opacity: 'show', height: 'show'}, 700, 'easeOutQuint');
        }
    });
    jQuery('.mobile-menu .menu-item-has-children > a').each(function(){
        jQuery(this).wrapAll( '<div class="parent"></div>');
        jQuery(this).parent('.parent').append('<div class="show-mb-submenu"><span class="fas fa-arrow-circle-right" title="Open ' + jQuery( this ).text() + ' Submenu"></span></div>');
    });
    jQuery('.show-mb-submenu').click(function(ev){
        ev.preventDefault();
        if ( jQuery(this).hasClass('active')) {
            jQuery(this).removeClass('active');
            jQuery(this).parents('.parent').siblings('ul').animate({opacity: 'hide', height: 'hide'}, 700, 'easeOutQuint');
        } else {
            jQuery(this).parents('.parent').parent('li').siblings('li').each(function(){
                if (jQuery(this).find('.show-mb-submenu').hasClass('active')) {
                    jQuery(this).find('.show-mb-submenu').removeClass('active');
                    jQuery(this).find('ul').animate({opacity: 'hide', height: 'hide'}, 700, 'easeOutQuint');
                }
            });
            jQuery(this).addClass('active');
            jQuery(this).parents('.parent').siblings('ul').animate({opacity: 'show', height: 'show'}, 700, 'easeOutQuint');
        }
    });

    // sort item functions
    jQuery('body').click(function(){
        jQuery('.sort-items .sort-item-top').removeClass('active');
        jQuery('.sort-items .sort-item-list').animate({opacity: 'hide', height: 'hide'}, 700, 'easeOutQuint', function () {});
    });
    jQuery('.sort-item').click(function(ev) {
        ev.stopPropagation();
    });
    jQuery('.sort-item .sort-item-top').click(function(){
        if ( jQuery(this).hasClass('active')) {
            jQuery(this).removeClass('active');
            jQuery(this).siblings('.sort-item-list').animate({opacity: 'hide', height: 'hide'}, 700, 'easeOutQuint');
        } else {
            jQuery(this).parents('li').siblings('li').each(function(){
                if (jQuery(this).find('.sort-item-top').hasClass('active')) {
                    jQuery(this).find('.sort-item-top').removeClass('active');
                    jQuery(this).find('.sort-item-list').animate({opacity: 'hide', height: 'hide'}, 700, 'easeOutQuint', function () {});
                }
            });
            jQuery(this).addClass('active');
            jQuery(this).siblings('.sort-item-list').animate({opacity: 'show', height: 'show'}, 700, 'easeOutQuint');
        }
    });

		// All labels for radio and checkbox fields to be focusable. Workaround for frontend visual modifications.
		jQuery( '.ginput_container_radio, .ginput_container_checkbox' ).each( function() {
			jQuery( this ).find( 'label' ).attr( 'tabindex', 0 );
		});

		// Add class to radio/checkbox label so we can listen for keypress to select the focused option.
		// Running keyup on the initial focus was failing when Shift + tab was combined to get to the previous option.
		jQuery( '.gform_wrapper label' ).on( 'focus', function( e ) {
			jQuery( '.form-label-focus' ).removeClass( 'form-label-focus' );
			jQuery( this ).addClass( 'form-label-focus' );
		});

		// Workaround for selecting Radio/Checkbox option by keypress of Enter or Spacebar.
		jQuery( 'html' ).on( 'keyup', '.form-label-focus' , function( e ) {
			if ( e.keyCode === 13 || e.keyCode === 32 ) {
				jQuery( this ).siblings( 'input' ).trigger( 'click' );
			}
		});

    /* styling selects */
    jQuery('select').selectize();

		// Add Title attribute to select box to avoid ADA select not being labeled (even though it's hidden and tabindex="-1").
		jQuery( '.selectized' ).each( function() {
			var title = jQuery( this ).attr( 'aria-label' );
			if ( ! title ) {
				title = jQuery( this ).siblings( 'label' ).text();
			}
			jQuery( this ).attr( 'title', title );
		});

    // responsive tables
    jQuery(window).on('load', function(){
        jQuery('.wysiwyg table').each(function(){
            jQuery(this).wrap('<div class="table-holder"></div>').promise().done(function(){
                jQuery(this).parent('.table-holder').append('<span class="msg">Swipe horizontally to view all fields.</span>');
            });
            var Twidth = jQuery(this).width();
            var Pwidth = jQuery(this).parent('.table-holder').width();
            if (Pwidth < Twidth) {
                jQuery(this).parent('.table-holder').find('.msg').show();
            } else {
                jQuery(this).parent('.table-holder').find('.msg').hide();
            }
        });
    });
    jQuery(window).on('resize', function(){
        jQuery('.wysiwyg table').each(function(){
            var Twidth = jQuery(this).width();
            var Pwidth = jQuery(this).parent('.table-holder').width();
            if (Pwidth < Twidth) {
                jQuery(this).parent('.table-holder').find('.msg').show();
            } else {
                jQuery(this).parent('.table-holder').find('.msg').hide();
            }
        });
    });

    jQuery(window).on('load', function(){
        setTimeout(function(){ jQuery('body').addClass('show-play') }, 3000);
    });

    // schedule
    jQuery(window).on('load', function(){
        if (jQuery('.schedule').length) {
            jQuery('.schedule .bg-image').css('top', - jQuery(window).height() / 5 +'px');
            if (isAppearIntoView(jQuery('.schedule'))) {
                var $Uparallax = jQuery('.schedule .bg-image');
                var UparallaxTop = jQuery('.schedule').offset().top;
                var winHeight = jQuery(window).height();
                var yPos = (jQuery(window).scrollTop() - (UparallaxTop - winHeight)) / 5;
                $Uparallax.css({ "transform": "translate3d(0px, " + yPos + "px, 0px)" });
            }
        }
    });
    jQuery(window).on('scroll', function(){
        if (jQuery('.schedule').length) {
            if (isAppearIntoView(jQuery('.schedule'))) {
                var $Uparallax = jQuery('.schedule .bg-image');
                var UparallaxTop = jQuery('.schedule').offset().top;
                var winHeight = jQuery(window).height();
                var yPos = (jQuery(window).scrollTop() - (UparallaxTop - winHeight)) / 5;
                $Uparallax.css({ "transform": "translate3d(0px, " + yPos + "px, 0px)" });
            }
        }
    });
    jQuery(window).on('resize', function(){
        jQuery('.schedule .bg-image').css('top', - jQuery(window).height() / 5 +'px');
    });

    // recent posts functions
    jQuery('.recent-posts .slides').slick({
        speed: 500,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: false,
        dots: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false
              }
            }
        ]
    });

    // Staff functions
    jQuery('.entry-staff-content').click(function(ev){
        ev.stopPropagation();
    });
    var firstDone = false;
    jQuery('.entry-staff-image, .entry-staff-details').click(function(ev){
        ev.stopPropagation();

        if(firstDone === true) {
            return;
        } else {

            if ( jQuery(this).parent('.entry-staff').hasClass('active') ) {
                jQuery(this).parent('.entry-staff').removeClass('active');
                var optHeight = jQuery(this).parent('.entry-staff').children('.entry-staff-content').height();
                jQuery(this).parent('.entry-staff').children('.entry-staff-content').animate({
                    'height': 0+'px'
                  }, 700, 'easeOutQuint', function() {
                    jQuery(this).css('display', 'none');
                    jQuery(this).css('height', optHeight+'px');
                });
                jQuery(this).parent('.entry-staff').animate({
                    'marginBottom': 0 +'px'
                  }, 700, 'easeOutQuint', function() {
                });
            } else {

                firstDone = true;

                jQuery(this).parent('.entry-staff').siblings('.entry-staff').each(function(){
                    jQuery(this).removeClass('active');
                    jQuery(this).animate({
                        'marginBottom': 0+'px'
                      }, 700, 'easeOutQuint', function() {
                    });
                    var optHeight = jQuery(this).children('.entry-staff-content').height();
                    jQuery(this).children('.entry-staff-content').animate({
                        'height': 0+'px'
                      }, 700, 'easeOutQuint', function() {
                        jQuery(this).css('display', 'none');
                        jQuery(this).css('height', optHeight+'px');
                    });
                });

                jQuery(this).parent('.entry-staff').addClass('active');
                var optHeight = jQuery(this).parent('.entry-staff').children('.entry-staff-content').height();
                jQuery(this).parent('.entry-staff').children('.entry-staff-content').css('height', 0+'px');
                jQuery(this).parent('.entry-staff').children('.entry-staff-content').css('display', 'block');
                jQuery(this).parent('.entry-staff').children('.entry-staff-content').animate({
                    'height': optHeight+'px'
                  }, 700, 'easeOutQuint', function() {
                    jQuery(this).css('height', 'auto');
                });
                jQuery(this).parent('.entry-staff').animate({
                    'marginBottom': optHeight +'px'
                  }, 700, 'easeOutQuint', function() {
                    var PitemOffset = jQuery(this).offset();
                    var windowW = jQuery(window).width();
                    if (windowW >= 992) {
                        jQuery("html, body").animate({scrollTop: (PitemOffset.top - 109)}, 700, 'easeOutQuint');
                    } else {
                        jQuery("html, body").animate({scrollTop: (PitemOffset.top - 39)}, 700, 'easeOutQuint');
                    }
                    firstDone = false
                });
            }

        }

    });
    jQuery('html').click(function() {
        jQuery('.entry-staff').each(function(){
            if ( jQuery(this).hasClass('active') ) {
                jQuery(this).removeClass('active');
                var optHeight = jQuery(this).children('.entry-staff-content').height();
                jQuery(this).children('.entry-staff-content').animate({
                    'height': 0+'px'
                  }, 700, 'easeOutQuint', function() {
                    jQuery(this).css('display', 'none');
                    jQuery(this).css('height', optHeight+'px');
                });
                jQuery(this).animate({
                    'marginBottom': 0 +'px'
                  }, 700, 'easeOutQuint', function() {
                });
            }
        });
    });
    jQuery('.entry-staff .staff-close').click(function() {
        jQuery(this).parents('.entry-staff').removeClass('active');
        jQuery(this).parents('.entry-staff').find('.show-bio').removeClass('active');
        var optHeight = jQuery(this).parents('.entry-staff').children('.entry-staff-content').height();
        jQuery(this).parents('.entry-staff').children('.entry-staff-content').animate({
            'height': 0+'px'
          }, 700, 'easeOutQuint', function() {
            jQuery(this).css('display', 'none');
            jQuery(this).css('height', optHeight+'px');
        });
        jQuery(this).parents('.entry-staff').animate({
            'marginBottom': 0 +'px'
          }, 700, 'easeOutQuint', function() {
        });
    });

    // home rotator functions
    var time = 8;
    var $bar,
        $slick,
        isPause,
        tick,
        percentTime;
    $slick = jQuery('.home-rotator .slides');
    $slick.slick({
    draggable: true,
    fade: true,
    adaptiveHeight: false,
    dots: false,
    arrows: false,
    mobileFirst: true,
    pauseOnDotsHover: true,
    });
    $bar = $('.slider-progress .progress-sd');
    jQuery('.slider-wrapper').on({
    mouseenter: function() {
      isPause = true;
    },
    mouseleave: function() {
      isPause = false;
    }
    })
    function startProgressbar() {
    resetProgressbar();
    percentTime = 0;
    isPause = false;
    tick = setInterval(interval, 10);
    }
    function interval() {
    if(isPause === false) {
      percentTime += 1 / (time+0.1);
      $bar.css({
        width: percentTime+"%"
      });
      if(percentTime >= 100)
        {
          $slick.slick('slickNext');
          startProgressbar();
        }
    }
    }
    function resetProgressbar() {
        $bar.css({
            width: 0+'%'
        });
        clearTimeout(tick);
    }
    startProgressbar();
    jQuery('.home-rotator .slide').each(function(){
        var $HRparallax = jQuery(this).find('.image');
        var yPos = jQuery(window).scrollTop() / 5;
        $HRparallax.css({ "transform": "translate3d(0px, " + yPos + "px, 0px)" });
        jQuery(window).scroll(function() {
            var yPos = jQuery(window).scrollTop() / 5;
            $HRparallax.css({ "transform": "translate3d(0px, " + yPos + "px, 0px)" });
        });
    });

    /* home-info */
    jQuery('.home-info .show-overlay').click(function(ev){
        ev.preventDefault();
        if ( jQuery(this).parents('.home-info-item').hasClass('active')) {
            jQuery(this).parents('.home-info-item').removeClass('active');
            jQuery(this).parents('.home-info-item').find('.overlay').animate({opacity: 'hide', height: 'hide'}, 700, 'easeOutQuint');
        } else {
            jQuery(this).parents('.home-info-item').siblings('.home-info-item').each(function(){
                if (jQuery(this).hasClass('active')) {
                    jQuery(this).removeClass('active');
                    jQuery(this).find('.overlay').animate({opacity: 'hide', height: 'hide'}, 700, 'easeOutQuint');
                }
            });
            jQuery(this).parents('.home-info-item').addClass('active');
            jQuery(this).parents('.home-info-item').find('.overlay').animate({opacity: 'show', height: 'show'}, 700, 'easeOutQuint');
        }
    });
    var stc = false;
    if (jQuery('.home-info').length && !stc) {
        if (isIntoViewE(jQuery('.home-info'))) {
            stc = true;
            jQuery('.home-info .top').animate({opacity: 1}, 700, 'easeOutQuint');
            jQuery('.home-info .count').each(function () {
                jQuery(this).prop('Counter',0).animate({
                    Counter: jQuery(this).text()
                }, {
                    duration: 4000,
                    easing: 'swing',
                    step: function (now) {
                        jQuery(this).text(Math.ceil(now));
                    }
                });
            });
        }
    }

    jQuery(window).on('load', function(){
        if (jQuery('.home-info').length) {
            jQuery('.home-info .bg-l').css('top', - jQuery(window).height() / 15 +'px');
            if (isAppearIntoView(jQuery('.home-info'))) {
                var $HILpx = jQuery('.home-info .bg-l');
                var HILpxTop = jQuery('.home-info').offset().top;
                var winHeight = jQuery(window).height();
                var yPos = (jQuery(window).scrollTop() - (HILpxTop - winHeight)) / 15;
                $HILpx.css({ "transform": "translate3d(0px, " + yPos + "px, 0px)" });
            }
            jQuery('.home-info .bg-s').css('top', - jQuery(window).height() / 10 +'px');
            if (isAppearIntoView(jQuery('.home-info'))) {
                var $HISpx = jQuery('.home-info .bg-s');
                var HISpxTop = jQuery('.home-info').offset().top;
                var winHeight = jQuery(window).height();
                var yPos = (jQuery(window).scrollTop() - (HISpxTop - winHeight)) / 10;
                $HISpx.css({ "transform": "translate3d(0px, " + yPos + "px, 0px)" });
            }
            if (isAppearIntoView(jQuery('.home-info-ct'))) {
                var $HIPpx = jQuery('.home-info-ct');
                var HIPpxTop = jQuery('.home-info-ct').offset().top;
                var winHeight = jQuery(window).height();
                var yPos = (jQuery(window).scrollTop() - (HIPpxTop - winHeight)) / 5;
                $HIPpx.css({ "transform": "translate3d(0px, " + yPos + "px, 0px)" });
            }
        }
    });
    jQuery(window).on('scroll', function(){
        if (jQuery('.home-info').length) {
            if (isAppearIntoView(jQuery('.home-info'))) {
                var $HILpx = jQuery('.home-info .bg-l');
                var HILpxTop = jQuery('.home-info').offset().top;
                var winHeight = jQuery(window).height();
                var yPos = (jQuery(window).scrollTop() - (HILpxTop - winHeight)) / 15;
                $HILpx.css({ "transform": "translate3d(0px, " + yPos + "px, 0px)" });
            }
            if (isAppearIntoView(jQuery('.home-info'))) {
                var $HISpx = jQuery('.home-info .bg-s');
                var HISpxTop = jQuery('.home-info').offset().top;
                var winHeight = jQuery(window).height();
                var yPos = (jQuery(window).scrollTop() - (HISpxTop - winHeight)) / 10;
                $HISpx.css({ "transform": "translate3d(0px, " + yPos + "px, 0px)" });
            }
            if (isAppearIntoView(jQuery('.home-info-ct'))) {
                var $HIPpx = jQuery('.home-info-ct');
                var HIPpxTop = jQuery('.home-info-ct').offset().top;
                var winHeight = jQuery(window).height();
                var yPos = (jQuery(window).scrollTop() - (HIPpxTop - winHeight)) / 5;
                $HIPpx.css({ "transform": "translate3d(0px, " + yPos + "px, 0px)" });
            }
        }
    });
    jQuery(window).on('resize', function(){
        jQuery('.home-info .bg-l').css('top', - jQuery(window).height() / 15 +'px');
        jQuery('.home-info .bg-s').css('top', - jQuery(window).height() / 5 +'px');
    });

    // home-stories functions
    jQuery('.home-stories .slides').slick({
        speed: 500,
        arrows: true,
        autoplay: false,
        autoplaySpeed: 5000,
        pauseOnHover: false,
        dots: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
        ]
    });
    jQuery('.home-stories .slides .story').click(function(){
        var $data = jQuery( this ).find( '.story-stage' ).html().replace( /svg-inline--fa-title-/g, 'svg-inline--fa-title-content-' ); // Added the replace for ADA succession when an element is clicked.
        jQuery('.home-stories-stage-ct').html('');
        jQuery('.home-stories-stage-ct').html($data);
    });

		jQuery( '.home-stories .slides .story-focus' ).keyup( function( e ) {
			if ( e.keyCode === 13 ) {
				jQuery( this ).parent( '.story' ).trigger( 'click' );
			}
		});

    // faq
    jQuery(window).on('load', function(){
        if (jQuery('.faq').length) {
            jQuery('.faq .bg-image').css('top', - jQuery(window).height() / 5 +'px');
            if (isAppearIntoView(jQuery('.faq'))) {
                var $Uparallax = jQuery('.faq .bg-image');
                var UparallaxTop = jQuery('.faq').offset().top;
                var winHeight = jQuery(window).height();
                var yPos = (jQuery(window).scrollTop() - (UparallaxTop - winHeight)) / 5;
                $Uparallax.css({ "transform": "translate3d(0px, " + yPos + "px, 0px)" });
            }
        }
    });
    jQuery(window).on('scroll', function(){
        if (jQuery('.faq').length) {
            if (isAppearIntoView(jQuery('.faq'))) {
                var $Uparallax = jQuery('.faq .bg-image');
                var UparallaxTop = jQuery('.faq').offset().top;
                var winHeight = jQuery(window).height();
                var yPos = (jQuery(window).scrollTop() - (UparallaxTop - winHeight)) / 5;
                $Uparallax.css({ "transform": "translate3d(0px, " + yPos + "px, 0px)" });
            }
        }
    });
    jQuery(window).on('resize', function(){
        jQuery('.faq .bg-image').css('top', - jQuery(window).height() / 5 +'px');
    });
    jQuery( '.faq-content h3, .faq-content .h3' ).click( function( ev ) {
        ev.preventDefault();
        ev.stopPropagation();
        if ( jQuery(this).hasClass('active')) {
            jQuery(this).removeClass('active');
            jQuery( this ).parents( 'li' ).find( '.answer' ).animate( { height: 'hide' }, 700, 'easeOutQuint' );
        } else {
            jQuery('.faq-content ul li').each(function(){
                if (jQuery( this ).find( 'h3' ).hasClass( 'active' ) || jQuery( this ).find( '.h3' ).hasClass( 'active' ) ) {
										jQuery( this ).find( '.h3' ).removeClass( 'active' );
                    jQuery(this).find('h3').removeClass('active');
                    jQuery(this).find('.answer').animate({height: 'hide'}, 700, 'easeOutQuint');
                }
            });
            jQuery(this).addClass('active');
            jQuery(this).parents( 'li' ).find( '.answer' ).animate( { height: 'show' }, 700, 'easeOutQuint', function(){
                var fitemOffset = jQuery(this).offset().top;
                var windowW = jQuery(window).width();
                if (windowW >= 992) {
                } else {
                    jQuery("html, body").animate({scrollTop: (fitemOffset - 160)}, 700, 'easeOutQuint');
                }
            });
        }
    });
	jQuery( '.sr-faq-trigger' ).click( function() {
		jQuery( this ).children( '.h3' ).trigger( 'click' );
	});

    // upcoming-speakers
    jQuery(window).on('load', function(){
        if (jQuery('.upcoming-speakers').length) {
            jQuery('.upcoming-speakers .bg-image').css('top', - jQuery(window).height() / 5 +'px');
            if (isAppearIntoView(jQuery('.upcoming-speakers'))) {
                var $Uparallax = jQuery('.upcoming-speakers .bg-image');
                var UparallaxTop = jQuery('.upcoming-speakers').offset().top;
                var winHeight = jQuery(window).height();
                var yPos = (jQuery(window).scrollTop() - (UparallaxTop - winHeight)) / 5;
                $Uparallax.css({ "transform": "translate3d(0px, " + yPos + "px, 0px)" });
            }
        }
    });
    jQuery(window).on('scroll', function(){
        if (jQuery('.upcoming-speakers').length) {
            if (isAppearIntoView(jQuery('.upcoming-speakers'))) {
                var $Uparallax = jQuery('.upcoming-speakers .bg-image');
                var UparallaxTop = jQuery('.upcoming-speakers').offset().top;
                var winHeight = jQuery(window).height();
                var yPos = (jQuery(window).scrollTop() - (UparallaxTop - winHeight)) / 5;
                $Uparallax.css({ "transform": "translate3d(0px, " + yPos + "px, 0px)" });
            }
        }
    });
    jQuery(window).on('resize', function(){
        jQuery('.upcoming-speakers .bg-image').css('top', - jQuery(window).height() / 5 +'px');
    });

     // bottom cta
    jQuery(window).on('load', function(){
        if (jQuery('.bottom-cta').length) {
            jQuery('.bottom-cta .bg-image').css('top', - jQuery(window).height() / 5 +'px');
            if (isAppearIntoView(jQuery('.bottom-cta'))) {
                var $Uparallax = jQuery('.bottom-cta .bg-image');
                var UparallaxTop = jQuery('.bottom-cta').offset().top;
                var winHeight = jQuery(window).height();
                var yPos = (jQuery(window).scrollTop() - (UparallaxTop - winHeight)) / 5;
                $Uparallax.css({ "transform": "translate3d(0px, " + yPos + "px, 0px)" });
            }
        }
    });
    jQuery(window).on('scroll', function(){
        if (jQuery('.bottom-cta').length) {
            if (isAppearIntoView(jQuery('.bottom-cta'))) {
                var $Uparallax = jQuery('.bottom-cta .bg-image');
                var UparallaxTop = jQuery('.bottom-cta').offset().top;
                var winHeight = jQuery(window).height();
                var yPos = (jQuery(window).scrollTop() - (UparallaxTop - winHeight)) / 5;
                $Uparallax.css({ "transform": "translate3d(0px, " + yPos + "px, 0px)" });
            }
        }
    });
    jQuery(window).on('resize', function(){
        jQuery('.bottom-cta .bg-image').css('top', - jQuery(window).height() / 5 +'px');
    });

	// Style all selects except those belonging to The Events Calendar
	jQuery('select:not(select[class*="tribe-"])').selectize();

});

function isAppearIntoView(elem)
{
    if (jQuery(elem).length) {
        var docViewTop = jQuery(window).scrollTop();
        var docViewBottom = docViewTop + jQuery(window).height();

        var elemTop = jQuery(elem).offset().top;
        var elemHeight = jQuery(elem).outerHeight();
        var elemBottom = elemTop + elemHeight;
    }

    return (elemTop <= docViewBottom && elemBottom >= docViewTop);
}

function isIntoView(elem)
{
    if (elem.length) {
        var docViewTop = jQuery(window).scrollTop();
        var docViewBottom = docViewTop + jQuery(window).height();
        var elemTop = jQuery(elem).offset().top;
        var elemHeight = jQuery(elem).outerHeight();
        var elemBottom = elemTop + elemHeight;
        return (elemBottom <= docViewBottom);
    }
}

function isIntoViewE(elem)
{
    if (elem.length) {
        var docViewTop = jQuery(window).scrollTop();
        var docViewBottom = docViewTop + jQuery(window).height();
        var elemTop = jQuery(elem).offset().top;
        var elemHeight = jQuery(elem).outerHeight();
        var elemBottom = elemTop + elemHeight;
        return ((elemTop + (elemHeight/2)) <= docViewBottom);
    }
}

function has_bbformFinished() {
	if ( jQuery( '#bbox-root img' ).length <= 1 ) {
		setTimeout( function() {
			jQuery( '.bbox-msg-wrapper img').attr( 'alt', 'Loading a 3rd Party Form' );
			jQuery( 'iframe[id*="easyXDM"]').attr( 'title', 'Popup for What Are Security Codes?');
		}, 100 );
		return false;
	} else {
		return true;
	}
}

function add_bbFormImgAlt() {
	jQuery( '#bbox-root img' ).each( function() {
		var card_type = jQuery( this ).data('card-type' );
		if ( undefined !== card_type && '' !== card_type ) {
			jQuery( this ).attr( 'alt', card_type );
		} else if ( 'bbox-msg-wrapper' === jQuery( this ).parent().attr( 'id' ) ) {
			jQuery( this ).attr( 'alt', 'Loading a 3rd Party Form' );
			jQuery( 'iframe[id*="easyXDM"]').removeAttr( 'frameborder' ).css( 'border', '0' ).attr( 'title', 'Container for loading scripts from 3rd Party.');
		}
	});
}
